import React from "react";
import "../css/footer.css";
// import logo from "../image/logo.png";
import { Link } from "react-router-dom";
function Footer(props) {
  const date = new Date().getFullYear();
  return (
    <>
      <footer>
        <div className="fsocial">
          <span>Get Connected with us in Social Media</span>
          <ul>
            <a href="https://www.facebook.com/abidadhikarics/" target="_blank" rel="noreferrer">
              <li>
                <i class="fab fa-facebook"></i>
              </li>
            </a>
            <a href="https://www.instagram.com/abid.adhikari/" target="_blank" rel="noreferrer">
              <li>
                <i class="fab fa-instagram"></i>
              </li>
            </a>
            <a href="https://twitter.com/AbidAdhikari" target="_blank" rel="noreferrer">
              <li>
                <i class="fab fa-twitter"></i>
              </li>
            </a>
            <a href="https://github.com/abidadhikari/" target="_blank" rel="noreferrer">
              <li>
                <i class="fab fa-github"></i>
              </li>
            </a>
          </ul>
        </div>
        <div className="fnav">
          <div className="navelement">
            <span>BlogPoint</span>
            <div>
              
Welcome to BlogPoint, your number one source for all things blog. We're dedicated to providing you the best , with a focus on dependability and  customer service.<br/>


 We hope you enjoy our products as much as we enjoy offering them to you.
<br/>
<br/>
Sincerely,
<br/>
<div style={{color:"rgba(9, 161, 9)"}}>Abid Adhikari</div>


            </div>
          </div>
          <div className="navelement">
            <span>Category</span>
            <ul>
              <Link to="/category/general">
                <li>General</li>
              </Link>
              <Link to="/category/technology">
                <li>Technology</li>
              </Link>
              <Link to="/category/sports">
                <li>Sports</li>
              </Link>
              <Link to="/category/health">
                <li>Health</li>
              </Link>
              <Link to="/category/movies">
                <li>Movies</li>
              </Link>
              <Link to="/category/bio">
                <li>Bio</li>
              </Link>
            </ul>
          </div>
          <div className="navelement">
            <span>Useful links</span>
            <ul>
              <Link to="/dashboard/myaccount">
                <li>My Account</li>
              </Link>
              <Link to="/login">
                <li>Login</li>
              </Link>
              <Link to="/logout">
                <li>Logout</li>
              </Link>
              <Link to="/">
                <li>Home</li>
              </Link>
            </ul>
          </div>
          <div className="navelement">
            <span>Contact</span>
            <ul>
            <li><i className="fas fa-home"></i>&nbsp;&nbsp;NayaBato Thimi - Bhaktapur,Nepal</li>
              <a href="mailto:abidadhikari778@gmail.com"><li><i className="fas fa-envelope"></i>&nbsp;&nbsp;Contact us</li></a>
              
            </ul>
          </div>
        </div>
        <div className="fcredit">
          {/* <Link href="/">
            <img src={logo} alt="blogpoint by abidadhikari logo" />
          </Link> */}
          <span> &copy; Copyright {date}:BlogPoint</span>
        </div>
      </footer>
    </>
  );
}

export default Footer;
